/**
 * Klikevents voor het meetplan van het home/collectie-redesign (handoff §5), via
 * Shopify.analytics.publish zoals de rest van het redesign.
 *
 * Eén luisteraar voor de hele pagina: een element met data-track="<event>" en
 * data-track-payload='{"…":…}' publiceert dat event zodra er een link of knop binnenin
 * wordt aangeklikt. Zo hoeft een kaart of tegel geen eigen script te dragen, en tellen
 * ook kaarten die later in de pagina komen (meer laden, filteren). Genest mag: een
 * kaart in het cadeaublok stuurt card_click én home_gift_pick_click.
 *
 * Gebruikt door: card_click (snippets/catalog-card.liquid), home_mood_tile_click,
 * home_gift_pick_click.
 */
if (!window.__trackClickInit) {
  window.__trackClickInit = true;

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const control = target?.closest('a, button');
      let tracked = control?.closest('[data-track]');

      while (tracked instanceof HTMLElement) {
        let payload = {};
        try {
          payload = JSON.parse(tracked.dataset.trackPayload || '{}');
        } catch (error) {
          // een kapotte payload mag de klik niet tegenhouden
        }

        try {
          window.Shopify?.analytics?.publish(tracked.dataset.track || '', payload);
        } catch (error) {
          // tracking mag nooit in de weg zitten
        }

        tracked = tracked.parentElement?.closest('[data-track]');
      }
    },
    { capture: true }
  );
}
